const firebaseConfig = {
  apiKey: "AIzaSyAbsWebugzH5Pq0W6Wkjw2rOrak1D9mToY",
  authDomain: "red-onion-0.firebaseapp.com",
  projectId: "red-onion-0",
  storageBucket: "red-onion-0.appspot.com",
  messagingSenderId: "529556250863",
  appId: "1:529556250863:web:e6195902b2c33c7e57bb1a",
};
export default firebaseConfig;
